
/* Helper functions
 */

_.mixin({

    /* Convert the given hexadecimal value (with or without the leading '#') to
     * an object with red, green, and blue values separated.
     */
    extractColourFromHex : function(hex) {
        var hexadecimal = (hex.charAt(0) == "#") ? hex.substring(1, 7) : hex;
        return {
            red   : parseInt(hexadecimal.substring(0, 2), 16),
            green : parseInt(hexadecimal.substring(2, 4), 16),
            blue  : parseInt(hexadecimal.substring(4, 6), 16)
        };
    }
});

/* We're using Coffeescript-style bound functions on object. This allows us to
 * ensure that event handlers defined on our Jitensha object can access the
 * Jitensha object.
 */
// var __bind = function(fn, me) {
//     return function() {
//         return fn.apply(me, arguments);
//     };
// };

/* This is the theme "class."
 */
var Jitensha = (function() {

    function Jitensha() {

        this.settings = {
            slideshowDelay     : 5000,
            slideshowSpeed     : 250,
            dropdownBackground : _('#000000').extractColourFromHex(),
            accentColor        : '#c90000'
        };

        this.enableSlideshow();
        this.styleForms();
        this.styleProductImages();
        this.enableMasonry();
        this.setupNavigation();
        this.centerProductImages();
        this.setupBlogShareButton();
        this.doSomethingNotSure();

    }

    Jitensha.prototype.doSomethingNotSure = function() {

        // TODO: Figure out what this is doing and rename this function.

        $("select.loc_on_change").change(function () {
            if ($(this).attr("value") == "#") return false;
            window.location = $(this).attr("value");
        });

    };

    Jitensha.prototype.setupBlogShareButton = function() {

        var shareIconsVisible;

        $('html').click(function() {

            if ($('.blog_share_icons').css('display') === 'none') {
                shareIconsVisible = false;
            } else {
                shareIconsVisible = true;
            }

            if (shareIconsVisible) {
                $('.blog_share_icons').animate({
                    opacity : 0,
                    top     : '10px'
                }, 200, function () {
                    $(this).css({
                        display : -1337
                    }).toggle()
                });
                shareIconsVisible = false;
            }

        });

        $('.blog_share_icons a').first().addClass('first-link');
        $('.blog_share_icons a').last() .addClass('last-link');

        $('.blog_share').click(function (event) {

            if ($(this).children('.blog_share_icons').css('display') == 'none') {
                shareIconsVisible = false;
            } else {
                shareIconsVisible = true;
            }

            if (shareIconsVisible) {

                $(this).children('.blog_share_icons').animate({
                    opacity: 0,
                    top: '10px'
                }, 200, function () {
                    $(this).css('display', -1337).toggle()
                });

                shareIconsVisible = false;

            } else {

                $(this).children('.blog_share_icons').css('z-index', 7337).toggle().animate({
                    opacity: 1,
                    top: '25px'
                }, 200);
                shareIconsVisible = true;

            }

            event.stopPropagation();

        });

    };

    Jitensha.prototype.centerProductImages = function() {

        var centerImage = function (image) {
            if (image.outerWidth() == 0) return;

            var containerWidth  = image.parent().outerWidth();
            var containerHeight = image.parent().outerHeight();
            var imageWidth      = image.outerWidth();
            var imageHeight     = image.outerHeight();
            var ratio = containerWidth / containerHeight;

            if (image.outerWidth() / image.outerHeight() > ratio) {
                image.attr("height", Math.min(containerHeight, imageHeight));
            } else {
                image.attr("width", Math.min(containerWidth, imageWidth));
            }
            image.css({
                'left'        : '50%',
                'top'         : '50%',
                'margin-left' : -1 * image.outerWidth()  / 2 + 'px',
                'margin-top'  : -1 * image.outerHeight() / 2 + 'px'
            }).fadeTo("normal", 1);
        };

        $(".center_img img").each(function () {
            var productImage = $(this);

            if ($.browser.msie && $.browser.version.substring(0, 2) !== '8.') {
                var originalSource = productImage.attr("src");
                productImage.attr({
                    src : originalSource.substring(0, originalSource.lastIndexOf('?'))
                });
            }

            productImage.parent().imagesLoaded(function () {
                centerImage(productImage);
            });
        });
    };

    Jitensha.prototype.setupNavigation = function() {

        /* Add placeholder text.
         */
        $("input[placeholder]").each(function () {

            var $this = $(this);

            $this.val($this.attr("placeholder"));

            $this.focus(function () {
                if ($this.val() == $this.attr("placeholder")) {
                    $this.val("");
                }
            });

            $this.blur(function () {
                if ($this.val() == "") {
                    $this.val($this.attr("placeholder"));
                }
            });

        });

        /* Fix up navigation drop down menus.
         */
        var _that = this;
        $("#nav ul li ul").each(function () {

            if ($(this).find("li").length < 2) { return; }

            var parentItem = $(this).parent();

            parentItem.css({
                'z-index' : '1000'
            });

            if ($("html:first").hasClass("oldie")) {

                $(this).find("li a").css({
                    'background' : '#000000'
                });

            } else {

                var bgColour = _that.settings.dropdownBackground;

                $(this).find("li a").css({
                    'background-color' : 'rgba('+bgColour.red+','+bgColour.green+','+bgColour.blue+',0.75)'
                });

            }

            $(this).find('li').eq(1).addClass('first');
            $(this).find('li:last').addClass('last');

            var paper = Raphael($(this).find('li:first').get(0), 254, 10);

            var arrow = paper.path('M127 0L137 10L117 10 Z');
            arrow.attr({
                'stroke-width'   : 0,
                'fill'           : '#000000',
                'stroke-opacity' : 0,
                'stroke'         : null,
                'opacity'        : .75
            });

            parentItem.hover(
                function() { $(this).addClass("hover");    },
                function() { $(this).removeClass("hover"); });
            });
        };

    Jitensha.prototype.enableMasonry = function() {
        if (!($.browser.msie && parseInt($.browser.version, 10) === 7)) {
            $('.masonry:first').imagesLoaded(function () {
                $(this).masonry({
                    itemSelector : '.large_product'
                });
            });
        }
    };

    Jitensha.prototype.styleProductImages = function() {
        if (!window.img_data) { return; }

        this.productImagessWrapper = $('#product-photos');
        this.productImages  = this.productImagessWrapper.find('#image');

        var current_image = 0;

        if (img_data.length <= 1) return;

        this.activeProductImage = this.productImagessWrapper.find("a:first");
        this.waiting = false;

        var _that = this;
        this.productImagessWrapper.find("ul li a").each(function (n) {
            $(this).attr('data-index', n);
            $(this).click(function () {
                if (_that.waiting) return false;
                _that.waiting = true;
                _that.productImagessWrapper.find("ul li.active").removeClass("active");
                $(this).parent().addClass("active");
                _that.showNextProductImage(n);
                return false;
            });
        });
    };

    Jitensha.prototype.showNextProductImage = function(n) {

        this.productImages.css({
            height : this.activeProductImage.outerHeight()
        });

        var _that = this;
        this.activeProductImage.fadeOut("fast", function () {
            _that.loadProductImage(n);
        });
    };

    Jitensha.prototype.loadProductImage = function(n) {
        if (img_data[n].loaded) {

            this.showProductImage(n);

        } else {

            $("#photo-frame-bottom .cropper").addClass("loading");
            this.productImages.append('<a href="" id="product-img-' + n + '"><img src=""  class="product-photo-large" /></a>');
            var html = $("#product-img-" + n).hide();
            var _that = this;
            $(html).fancybox();
            $(html).find("img:first").load(function () {

                img_data[n].loaded = true;
                $("#photo-frame-bottom .cropper").removeClass("loading");
                _that.showProductImage(n);

            });

            this.productImages.addClass("loading");
            $(html).attr("href", img_data[n].src);
            $(html).find("img:first").attr("src", img_data[n].src);

        }
    };

    Jitensha.prototype.showProductImage = function(n) {

        this.activeProductImage.removeClass("active");
        this.activeProductImage = $("#product-img-" + n);

        this.activeProductImage.css({
            position : 'absolute'
        });

        var _that = this;
        this.productImages.animate({
            height: _that.activeProductImage.outerHeight()
        }, 'fast', function() {
            _that.productImages.removeClass("loading");
            $("#product-img-" + n).fadeIn("normal", function () {
                $("#product-img-" + n).css("width", $("#product-img-" + n + " img:first").outerWidth());
                _that.waiting = false;
            }).addClass("active");
        });
    }

    Jitensha.prototype.styleForms = function() {
        $("#sortable select").uniform({ selectClass: 'homeselector' });
        $(".uniform")        .uniform({ selectClass: 'selector' });
    };

    Jitensha.prototype.drawTag = function(tag) {

        var paper = Raphael(tag, 161, 90);
        var set = paper.set();

        set.push(
            paper.path("M 7.12 0.00 L 124.35 0.00 C 126.36 0.62 128.21 1.75 129.52 3.43 C 139.36 15.30 149.03 27.30 158.86 39.18 C 159.89 40.38 160.57 41.83 161.00 43.35 L 161.00 47.38 C 159.94 50.57 157.40 52.87 155.35 55.43 C 146.91 65.63 138.45 75.82 130.01 86.02 C 128.52 87.90 126.55 89.41 124.20 90.00 L 7.13 90.00 C 3.54 89.30 0.69 86.46 0.00 82.87 L 0.00 7.12 C 0.70 3.54 3.54 0.70 7.12 0.00 Z")
        );

        set.attr({
            'stroke-width'   : 0,
            'fill'           : this.settings.accentColor,
            'stroke-opacity' : 0,
            'stroke'         : null
        });

        var circle = paper.circle(144, 45, 6);

        circle.attr({
            'stroke-width'   : 0,
            'fill'           : '#FFF',
            'stroke-opacity' : 0,
            'stroke'         : null
        });
    };

    Jitensha.prototype.enableSlideshow = function() {
        // Find the slideshow.
        this.slideshow = $('#marquee');

        // Resize marquee text.
        $('#marquee_price').makeTextFit({
            min_size : 10,
            max_size : 57
        });

        this.slides       = this.slideshow.find(".slide");
        this.currentSlide = this.slides.first();
        this.slideZ       = 101;

        var _that = this;
        $(".svg_tag").each(function () {
            _that.drawTag($(this).attr("id"));
        });

        if (this.slides.length > 1) {
            setInterval(function() { _that.advanceSlideshow(); }, this.settings.slideshowDelay);
        }
    };

    Jitensha.prototype.advanceSlideshow = function() {

        if (this.slides.eq(0).outerHeight() == 0) {
            setTimer();
            return;
        }

        this.slideshow.css({
            height : this.slides.eq(0).outerHeight()
        });

        this.slides.css({
            position : 'absolute'
        });

        this.currentSlide.find('.slide_content') .fadeTo(this.settings.slideshowSpeed, 0);

        var nextSlide = this.currentSlide.next();
        if (!nextSlide.length) nextSlide = this.slides.first();

        nextSlide.css({
            'display' : 'none',
            'z-index' : ++this.slideZ
        }).fadeIn(this.settings.slideshowSpeed);

        nextSlide.find(".slide_content")
            .hide()
            .clearQueue()
            .delay(this.settings.slideshowSpeed * .75)
            .fadeTo(this.settings.slideshowSpeed, 1);

        this.currentSlide = nextSlide;
    };

    return Jitensha;

}());

/* Initialize the theme.
 */

$(function() { new Jitensha(); });
